import * as React from "react";
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import { Paper } from '@mui/material';
import ConfirmationDialogMoby from "../ConfirmationDialogMoby";


const DialogFiltr = (props) => {

  const onClick = () => {
    window.scrollTo({top: 0, behavior: 'smooth'});
    props.handleClose();
    window.location.href = `/${props.catalogUrl}/?${props.getUrlFiltr}&${props.valueSelected}`;   
}
    return (
        <>
        <Dialog
        fullScreen
        open={props.open}
        onClose={props.handleClose}
      >
        <AppBar sx={{ position: 'relative', backgroundColor: "#404040" }}>
          <Toolbar sx={{minHeight: "40px"}}>
            <IconButton
              edge="start"
              color="inherit"
              onClick={props.handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Фильтр
            </Typography>
            <Button autoFocus color="inherit" onClick={props.resetForm}>
              Очистить Фильтр
            </Button>
          </Toolbar>
        </AppBar>
        <ConfirmationDialogMoby {...props}  />
        <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }} elevation={3}>
          <Typography sx={{ p: 2, color: 'text.secondary', textAlign: 'center',color: "#ff6000" }}  onClick={onClick} >Показать {props.countItems} товаров</Typography>
        </Paper>
      </Dialog>
        </>
    )

}

export default DialogFiltr;